<template>
  <span :class="`traveler-label`">
    <traveler-icon :traveler="traveler_info" :color="sass('primary')"/>
    <span>
      Passeggero <span v-if="index >= 0">{{ index + 1 }} </span>
      <span v-else>{{ traveler_info.id }}</span>
    </span>
    <span v-if="traveler_info.traveler_type === 'ADULT'">(adulto)</span>
    <span v-else-if="is_child(traveler_info)">(bambino)</span>
    <span v-else-if="is_infant(traveler_info)">(neonato)</span>
    <span v-else>({{ traveler_info.traveler_type }})</span>
    <slot></slot>
  </span>
</template>

<script>
import { is_infant, is_child } from "@liveflight/utilities/mixins";
import TravelerIcon from "./traveler-icon.vue";

export default {
  name: "traveler-label",
  components: {
    "traveler-icon": TravelerIcon,
  },
  props: {
    traveler_info: Object,
    index: {
      type: Number,
      default: () => -1,
    }, 
  },
  methods: {
    is_infant,
    is_child,
  },
};
</script>

<style lang="scss" scoped>
.traveler-label {
  margin: 0;
  flex-grow: 1;
  text-align: left;
  
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>
